/**
 * Vehicle engine output unit values
 */
export enum VehicleEngineOutputUnitEnum {
	HP = 'hp',
	BHP = 'bhp',
	KW = 'kw',
	PS = 'ps',
}
